import React, { useContext, useEffect, useState } from 'react';
import {
  DialogContent,
  LinearProgress,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  FormControl,
  Alert,
} from '@mui/material';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import { ClearIcon } from '@mui/x-date-pickers';
import { format } from 'date-fns';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import axios from 'axios';
import {
  IDeliveryBatch,
  IPickupTask,
} from '../../../../interfaces/delivery-company/tasks';
import { TaskPrinter } from '../../../common/task-barcode-printer/task-barcode-printer';
import ReceiveOrdersForm from './receive-orders-form';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';

interface ReceiveOrdersDialogProps {
  task: IPickupTask;
  onClose: () => void;
}

function ReceiveOrdersDialog({ task, onClose }: ReceiveOrdersDialogProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { user, config } = useContext(AuthContext);
  const [taskData, setTaskData] = useState<IPickupTask>();

  useEffect(() => {
    if (task != null) {
      // fetch task orders
      setIsLoading(true);
      const getTaskData = async () => {
        const endpoint = `${API_ENDPOINT}/api/v1/pickup-task/${task.id}/`;
        try {
          console.log(endpoint);
          const response = await axios.get<IPickupTask>(endpoint, config);
          console.log(response);
          setTaskData(response.data);
        } catch (error) {
          console.log(error);
        }
        setIsLoading(false);
      };
      getTaskData();
    }
  }, [task?.id]);

  return (
    <CustomDialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      fullScreen={(isMobile && !isTablet)}
    >
      <div
        style={{
          textAlign: 'right',
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <DialogTitle textAlign="center">Receive Picked Up Orders</DialogTitle>
        <IconButton
          onClick={() => {
            onClose && onClose();
            setIsOpen(false);
          }}
        >
          <ClearIcon color="primary" fontSize="large" />
        </IconButton>
      </div>

      <DialogContent style={(isDesktop || isTablet) ? { width: 'auto', height: 'auto' } : {}}>
        {isLoading ? (
          <>
            Getting task details ... <br />
            <LinearProgress />
          </>
        ) : (
          <>
            {taskData ? (
              <ReceiveOrdersForm task={taskData} />
            ) : (
              <Alert severity="error">Failed to get task data</Alert>
            )}
          </>
        )}
      </DialogContent>
    </CustomDialog>
  );
}

export default ReceiveOrdersDialog;
